var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccinationsViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00b2db;}.cls-3{fill:#28d6e9;}.cls-4{fill:#d4fffe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.46,
    y: 0.23,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.46,
    y: 0.23,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "vaccinations_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.64.23a17,17,0,0,0-17,17V430.05a17,17,0,0,0,17,17H583.38a17,17,0,0,0,17-17V17.19a17,17,0,0,0-17-17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.61,
    y: 76.75,
    width: 380.77,
    height: 446.79,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.16,270.14V583.43a17,17,0,0,1-17.24,16.8H17.64A17,17,0,0,1,.39,583.43V170.24a17,17,0,0,1,17.25-16.8H261.33a17.7,17.7,0,0,1,5.85,1L379.61,263.19A16.26,16.26,0,0,1,381.16,270.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.91,263.8h-95a17.24,17.24,0,0,1-17.43-17V155Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.29,
    y: 372.81,
    width: 262.13,
    height: 36.46,
    rx: 12,
    transform: "translate(-2.96 1.43) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.41,
    y: 519.11,
    width: 133.68,
    height: 36.46,
    rx: 12,
    transform: "translate(-4.07 0.96) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.74,
    y: 299.9,
    width: 262.13,
    height: 36.46,
    rx: 12,
    transform: "translate(-2.41 1.43) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.85,
    y: 445.72,
    width: 261.36,
    height: 36.46,
    rx: 12,
    transform: "translate(-3.51 1.44) rotate(-0.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationsViewEntries);
export default __webpack_public_path__ + "static/media/vaccinations_view_entries.dc2691c856d2fdfd2b7064490c5552e2.svg";
export { ForwardRef as ReactComponent };